module.exports = __webpack_public_path__ + "img/hardware4.77950407.png";